import { render, staticRenderFns } from "./FormCharacterization.vue?vue&type=template&id=338772bc"
import script from "./FormCharacterization.vue?vue&type=script&lang=js"
export * from "./FormCharacterization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports